import { useMemo } from 'react';

import type { CardLayout } from '../../types';

import { Cards } from './Cards';

import type { UefatvEditorialContent } from '@shared-types/uefatv.types';

export const CardsGrouped = ({
  items,
  rowCount,
  layout,
  id,
}: {
  items: UefatvEditorialContent[];
  rowCount: number;
  layout?: CardLayout;
  id?: string;
}) => {
  // group items by rowCount
  const groupedItems = useMemo(
    () =>
      items.reduce((acc: UefatvEditorialContent[][], item, index) => {
        const groupIndex = Math.floor(index / rowCount);
        if (!acc[groupIndex]) {
          acc[groupIndex] = [];
        }
        acc[groupIndex].push(item);
        return acc;
      }, []),
    [items, rowCount],
  );

  return (
    <>
      {groupedItems.map((group) => (
        <div className='pk-display--flex pk-flex--column pk-gap--s' key={`c_${group.at(0).id}`}>
          <Cards id={id} items={group} layout={layout} grouped />
        </div>
      ))}
    </>
  );
};
